const KEYS = {
  contacts: 'contacts',
  daily: 'daily',
  dailyId: 'dailyId',
  contactId: 'contactId',
};

export default KEYS;